import React, { useContext } from "react";
import { Toggle } from "@fluentui/react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
import { hasGlobalSearchCriteria } from "../../../helpers/globalSearchHelpers";

const GlobalSearchToggle = () => {
  const {
    isGlobalSearch,
    setIsGlobalSearch,
    closeGlobalSearchSession,
    beginGlobalSearchSessionIfNeeded,
    searchDto,
    filterApplied,
    setFilterApplied,
    setGlobalSearchEmptyMessage,
    promptEmptyGlobalSearch,
  } = useContext(studylistContext);

  const onToggleChange = (_event, checked) => {
    const enabled = !!checked;
    if (!enabled) {
      closeGlobalSearchSession();
      return;
    }
    setIsGlobalSearch(true);
    if (hasGlobalSearchCriteria(searchDto)) {
      setGlobalSearchEmptyMessage(null);
      beginGlobalSearchSessionIfNeeded(true, true);
      setFilterApplied(filterApplied + 1);
    } else {
      promptEmptyGlobalSearch?.();
      beginGlobalSearchSessionIfNeeded(true, true);
    }
  };

  const tooltipContent = isGlobalSearch
    ? "Search across all workflow tabs. Matching studies open in All Tabs."
    : "Turn on to search across all workflow tabs";

  return (
    <div className="data-toggle-button">
      <CustomToolTipHost content={tooltipContent}>
        <Toggle
          checked={!!isGlobalSearch}
          onChange={onToggleChange}
          onText="All Tabs"
          offText="All Tabs"
          styles={{
            root: {
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
              marginBottom: 0,
            },
            label: {
              whiteSpace: "nowrap",
            },
          }}
        />
      </CustomToolTipHost>
    </div>
  );
};

export default GlobalSearchToggle;
